export const page = {
	title: "Produtos",
	description: "Listagem e configuração de itens vendidos ao cliente final.",
	permissionError: "Você não possui as permissões",
	addProduct: "Adicionar produto",
	bulkImportProducts: "Importar produtos em massa",
};
